export const ACCOUNT_TYPES = {
  Main: 'Main',
  Trading: 'Trading',
  Commission: 'Commission',
} as const;

export type AccountTypeName = keyof typeof ACCOUNT_TYPES;

export type AccountLeverageDto = {
  isLocked: boolean;
  frozenLeverage: number;
  name: string;
  value: number;
};

export type AccountInfoDto = {
  accTypeName: AccountTypeName;
  accNum: string;
  accName?: string;
  created: string;
  tradingAccKey?: number;
  tradingProductCode?: string;
  tradingProductName?: string;
  leverage?: AccountLeverageDto;
};

export type AccountsInfoResponseDto = {
  autoRefeshCache: number;
  restsCacheLifeTime: number;
  accounts: Array<AccountInfoDto>;
};

export type AccountConfigurationCodeDto = {
  accountCode: string;
  accountCodeName: string;
  accountCodeDescription: string | null;
  isCreateActive: boolean;
  isMultiAsset: boolean;
  assets: Array<string> | null;
  leverage: Array<string> | null;
  allowedAccountsQuantityByAsset: number | null;
  allowedAccountsQuantityTotal: number | null;
};

export type AccountConfigurationTypeDto = {
  accountTypeCode: string;
  accountTypeName: string;
  displayOrder: number;
  accountCodes: Array<AccountConfigurationCodeDto>;
};

export type AccountsConfigurationsResponseDto = {
  eula: string | null;
  accountTypes: Array<AccountConfigurationTypeDto>;
};
